export const isTodaySunday = () => {
  return false //NO MORE SUNDAY
  //return new Date().getDay() === 0
}
